/**
 * Formats a full name.
 */
export function formatFullName(
  firstName: string | null | undefined,
  middleInitial: string | null | undefined,
  lastName: string | null | undefined,
) {
  return [
    firstName,
    // Middle initial is optional.
    middleInitial ? `${middleInitial}.` : null,
    lastName,
  ]
    .filter(Boolean)
    .join(' ')
    .trim()
}
